// make reducers
import entities from './entities';
import user from './user';
import ui from './ui';
import relationships from './relationships';
import notifications from './notifications';
import uuidMappings from './urlMappings';
import auth from './auth';
import { combineReducers } from 'redux';
import appConfig from './appConfig';

const rootReducer = combineReducers({
    entities,
    relationships,
    user,
    ui,
    notifications,
    uuidMappings,
    auth,
    appConfig,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
